import React, { useState } from "react";
import { Box, Paper, TextField, Button, Typography, InputAdornment, useMediaQuery, } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import LoginImg from "../assets/login.png";
import { useNavigate } from "react-router-dom";
import SnackbarAlert from "../components/SnackbarAlert";
export default function Login() {
    const isMobile = useMediaQuery("(max-width:900px)");
    const navigate = useNavigate();
    const [snackbar, setSnackbar] = useState(false);
    const [message, setMessage] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const handleLogin = () => {
        setEmailError(false);
        setPasswordError(false);
        let valid = true;
        if (email.trim() === "") { setEmailError(true); valid = false; }
        if (password.trim() === "") { setPasswordError(true); valid = false; }
        if (!valid) return;
        if (email === "admin@gmail.com" && password === "12345678") {
            navigate("/dashboard");
        } else {
            setMessage("Invalid User Name or Password");
            setSnackbar(true);
        }
    };
    return (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, minHeight: "100vh", fontFamily: "'Poppins', sans-serif", background: "#f0f2f5", }}>
            {!isMobile && (
                <Box sx={{ flex: 1, position: "relative", backgroundImage: `url(${LoginImg})`, backgroundSize: "cover", backgroundPosition: "center", display: { xs: "none", md: "block" }, }}>
                    <Box sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "linear-gradient(135deg, rgba(20,20,60,0.6), rgba(40,50,120,0.6))", }}></Box>
                    <Typography sx={{ position: "absolute", bottom: 40, left: 40, color: "#fff", fontSize: "1rem", fontWeight: 500, maxWidth: "60%", }}>Admin Panel - Power By Praneesh Infotech</Typography>
                </Box>
            )}
            <Box sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 3, }}>
                <Paper elevation={12} sx={{ width: "100%", maxWidth: 420, p: 5, borderRadius: 4, textAlign: "center", background: "#fff", boxShadow: "0 10px 30px rgba(0,0,0,0.2)", }}>
                    <Typography variant="h4" sx={{ mb: 1.5, fontWeight: 700, color: "#1f2a38" }}>Welcome Back</Typography>
                    <Typography sx={{ mb: 3, color: "#546e7a" }}>Sign in to your admin panel</Typography>
                    <TextField label="User Name" type="email" value={email} onChange={(e) => setEmail(e.target.value)} error={emailError} helperText={emailError ? "Email is required" : ""} fullWidth
                        sx={{ mb: 2, background: "#fff", borderRadius: 1, "& .MuiOutlinedInput-root": { boxShadow: "0 1px 3px rgba(0,0,0,0.1)", }, }}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><EmailIcon color="primary" /></InputAdornment>), }} />
                    <TextField label="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} error={passwordError} helperText={passwordError ? "Password is required" : ""}
                        fullWidth sx={{ mb: 3, background: "#fff", borderRadius: 1, "& .MuiOutlinedInput-root": { boxShadow: "0 1px 3px rgba(0,0,0,0.1)", }, }}
                        InputProps={{ startAdornment: (<InputAdornment position="start"><LockIcon color="primary" /></InputAdornment>), }} />
                    <Button variant="contained" fullWidth onClick={handleLogin} sx={{ py: 1.5, fontWeight: 600, mb: 2, borderRadius: 3, background: "linear-gradient(to right, #5a4de8, #2b7cf8)", boxShadow: "0 4px 15px rgba(0,0,0,0.2)", transition: "0.3s", "&:hover": { background: "linear-gradient(to right, #2b7cf8, #5a4de8)", boxShadow: "0 6px 20px rgba(0,0,0,0.25)", }, }}>Login</Button>
                </Paper>
            </Box>
            <SnackbarAlert open={snackbar} setOpen={setSnackbar} message={message} />
        </Box>
    );
}